// extracted by mini-css-extract-plugin
module.exports = {"x-axis":"GraphXAxis_x-axis___7wRr"};